import dynamic from 'next/dynamic'

const FillProfileStep = dynamic(() => import('./steps/fill-profile-step/fill-profile-step'))
const GotoNewslineStep = dynamic(() => import('./steps/goto-newsline-step/goto-newsline-step'))
const LKStep = dynamic(() => import('./steps/lk-step/lk-step'))
const CongratsStep = dynamic(() => import('./steps/congrats-step/congrats-step'))
const ChatStep = dynamic(() => import('./steps/chat-step/chat-step'))
const LKStepForActiveWebinar = dynamic(() => import('./steps/lk-step/lk-step-for-active-webinar'))

import { stepName } from 'constants/onboarding'

const useDefineOnboardingComponent = (step: stepName, finishStepHandler: () => void) => {
  const list = {
    [stepName.FILL_PROFILE]: <FillProfileStep finishStep={finishStepHandler} />,
    [stepName.GO_TO_NEWSLINE]: <GotoNewslineStep finishStep={finishStepHandler} />,
    [stepName.CONGRATS]: <CongratsStep finishStep={finishStepHandler} />,
    [stepName.LK]: <LKStep finishStep={finishStepHandler} />,
    [stepName.CHAT]: <ChatStep finishStep={finishStepHandler} />,
    [stepName.LK_ACTIVE_WEBINAR]: <LKStepForActiveWebinar finishStep={finishStepHandler} />,
  }

  return list[step]
}

export default useDefineOnboardingComponent
